import React from 'react';

// Ekip istatistik kartlarında kullanılan özel ekip ikonları.
// lucide-react'te karşılığı olmayan (çim biçme motoru, motorlu testere) veya
// daha gerçekçi görünmesi istenen (geniş blok boya fırçası) ekipler için
// currentColor ile çizilmiş tek renk SVG'ler — kartın metin rengini alırlar.

// Çim biçme motoru — itmeli elektrikli çim biçme makinesi (yan görünüm):
// büyük arka tekerlek, küçük ön tekerlek, gövde/motor ve yukarı uzanan kol.
export const LawnMowerIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* gövde / deck + tahliye ağzı */}
    <path d="M2.5 15.5v-3a1 1 0 0 1 1-1h8l1.8-2.5H16v6.5" />
    {/* motor kaputu */}
    <path d="M4.5 11.5V9a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v2.5" />
    {/* tekerlekler */}
    <circle cx="7" cy="17" r="2.6" />
    <circle cx="14.5" cy="18" r="1.7" />
    {/* itme kolu + tutamak */}
    <path d="M15.5 12.5 21.5 5" />
    <path d="M18.5 5h3.5" />
  </svg>
);

// Geniş blok boya fırçası (fotoğraftaki gibi): üstte tutamak, turuncu bilezik
// yerine geniş bilezik bandı ve aşağıda geniş kıl bloğu.
export const PaintBrushIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* tutamak */}
    <path d="M10 2.5q2-1 4 0l-1 5h-2z" />
    {/* bilezik bandı */}
    <rect x="4.5" y="7.5" width="15" height="3" rx="1" />
    {/* kıl bloğu */}
    <path d="M5 10.5h14l-1 9H6z" />
    {/* kıl çizgileri */}
    <path d="M9 11v8M12 11v8M15 11v8" />
  </svg>
);

// Motorlu testere (chainsaw) — solda kılavuz çubuğu + zincir, sağda motor
// gövdesi ve üstte taşıma kolu.
export const ChainsawIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* motor gövdesi */}
    <rect x="11" y="9" width="10" height="7" rx="2" />
    {/* taşıma kolu (üstte halka) */}
    <path d="M13 9V7a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v2" />
    {/* kılavuz çubuğu (sol) */}
    <path d="M11 11H3a1.3 1.3 0 0 0 0 2.6h8" />
    {/* zincir dişleri */}
    <path d="M4 10.4v.6M6.5 10.4v.6M9 10.4v.6M4 13.6v.6M6.5 13.6v.6M9 13.6v.6" />
  </svg>
);
